<template>
  <div class="measurement-calculation-sensor-tab">
    <div
      v-for="(field, index) in fields"
      class="measurement-calculation-sensor-tab__field"
      :key="index"
    >
      <basic-reference-field
        :field-name="field.fieldName"
        :field-value="field.fieldValue"
      />
      <div class="measurement-calculation-sensor-tab__info-badge">
        <info-badge
          v-if="field.showTooltip"
          translation-key="messages.MI035.message"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InfoBadge from '@/components/icon/InfoBadge';
import BasicReferenceField from './BasicReferenceField';

export default {
  name: 'MeasurementCalculationSensorTab',
  components: {
    BasicReferenceField,
    InfoBadge,
  },
  props: {
    winding: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fields() {
      const { winding } = this;
      return [
        {
          fieldName: 'fields.engineering.final-gradient.oil-temperature',
          fieldValue: winding.oilTemperature,
          showTooltip: false,
        },
        {
          fieldName: 'fields.engineering.final-gradient.winding-temperature',
          fieldValue: winding.windingTemperature,
          showTooltip: false,
        },
        {
          fieldName: 'fields.engineering.final-gradient.final-gradient',
          fieldValue: winding.finalGradient,
          showTooltip: false,
        },
        {
          fieldName: 'fields.engineering.final-gradient.expected-final-winding-temperature',
          fieldValue: winding.expectedFinalWindingTemperature,
          showTooltip: true,
        },
        {
          fieldName: 'fields.engineering.final-gradient.loading',
          fieldValue: winding.loading,
          showTooltip: false,
        },
      ];
    },
  },
};
</script>
<style lang="sass" scoped>
  .measurement-calculation-sensor-tab
    &__field
      display: flex
      flex-direction: row
      flex-wrap: nowrap
      justify-content: flex-end
      width: 100%
    &__info-badge
      display: flex
      align-items: center
      width: 20px
</style>
